import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { Message } from 'element-ui';

Vue.use(VueRouter)

let excludeRoutes = ["login", "401", "404","certificate_search"]; //不拦截的路由

const routes = [{
    path: '/login',
    name: 'login',
    component: resolve => require(['../views/login/index.vue'], resolve),
    meta: {
        title: "登录"
    }
}, {
    path: '/',
    name: 'main',
    component: resolve => require(['../views/main/index.vue'], resolve),
    meta: {
        title: "main"
    },
    children: [{
        path: '/console',
        name: 'console',
        component: resolve => require(['../views/console/index.vue'], resolve), //主页
        meta: {
            title: "主页",
            keepAlive: true
        }
    }, {
        path: '/org',
        name: 'org',
        component: resolve => require(['../views/org/index.vue'], resolve), //组织机构
        meta: {
            title: "组织机构",
            keepAlive: true
        }
    }, {
        path: '/contractor_type',
        name: 'contractor_type',
        component: resolve => require(['../views/contractor_type/index.vue'], resolve), //承包商类型
        meta: {
            title: "承包商类型",
            keepAlive: true
        }
    }, {
        path: '/contractor',
        name: 'contractor',
        component: resolve => require(['../views/contractor/index.vue'], resolve), //承包商管理
        meta: {
            title: "承包商管理",
            keepAlive: true
        }
    }, {
        path: '/contractor_post',
        name: 'contractor_post',
        component: resolve => require(['../views/contractor_post/index.vue'], resolve), //承包商岗位管理
        meta: {
            title: "岗位管理",
            keepAlive: true
        }
    }, {
        path: '/user',
        name: 'user',
        component: resolve => require(['../views/user/index.vue'], resolve), //用户管理
        meta: {
            title: "人员管理",
            keepAlive: true
        }
    }, {
        path: '/contractor_employee',
        name: 'contractor_employee',
        component: resolve => require(['../views/contractor_employee/index.vue'], resolve), //承包商员工管理
        meta: {
            title: "员工管理",
            keepAlive: true
        }
    }, {
        path: '/train_strategy',
        name: 'train_strategy',
        component: resolve => require(['../views/train_strategy/index.vue'], resolve), //培训策略
        meta: {
            title: "培训策略",
            keepAlive: true
        }
    }, {
        path: '/file',
        name: 'file',
        component: resolve => require(['../views/file/index.vue'], resolve), //资料库
        meta: {
            title: "资料库",
            keepAlive: true
        }
    }, {
        path: '/exam_strategy',
        name: 'exam_strategy',
        component: resolve => require(['../views/exam_strategy/index.vue'], resolve), //考试策略
        meta: {
            title: "考试策略",
            keepAlive: true
        }
    }, {
        path: '/exam_record',
        name: 'exam_record',
        component: resolve => require(['../views/exam_record/index.vue'], resolve), //考试记录
        meta: {
            title: "考试记录",
            keepAlive: true
        }
    }, {
        path: '/exam_subject',
        name: 'exam_subject',
        component: resolve => require(['../views/exam_subject/index.vue'], resolve), //考题库
        meta: {
            title: "考题库",
            keepAlive: true
        }
    }, {
        path: '/certificate',
        name: 'certificate',
        component: resolve => require(['../views/certificate/index.vue'], resolve), //证书管理
        meta: {
            title: "证书管理",
            keepAlive: true
        }
    }, {
        path: '/certificate_issue',
        name: 'certificate_issue',
        component: resolve => require(['../views/certificate_issue/index.vue'], resolve), //证书记录
        meta: {
            title: "证书记录",
            keepAlive: true
        }
    }, {
        path: '/my_info',
        name: 'my_info',
        component: resolve => require(['../views/my_info/index.vue'], resolve), //个人信息
        meta: {
            title: "个人信息",
            keepAlive: true
        }
    }, {
        path: '/update_password',
        name: 'update_password',
        component: resolve => require(['../views/update_password/index.vue'], resolve), //修改密码
        meta: {
            title: "修改密码",
            keepAlive: true
        }
    }]
}, {
    path: '/error',
    name: 'error',
    component: resolve => require(['../views/error/index.vue'], resolve), //错误页
    meta: {
        title: "错误",
    },
    children: [{
        path: '401',
        name: '401',
        component: resolve => require(['../views/error/401/index.vue'], resolve), //无权限
        meta: {
            title: "401",
        }
    }, {
        path: '404',
        name: '404',
        component: resolve => require(['../views/error/404/index.vue'], resolve), //404
        meta: {
            title: "404",
        }
    }]
}, {
    path: '/h5',
    name: 'h5',
    component: resolve => require(['../views/h5/index.vue'], resolve), //h5
    meta: {
        title: "错误",
    },
    children: [{
        path: 'certificate_search',
        name: 'certificate_search',
        component: resolve => require(['../views/h5/certificate_search/index.vue'], resolve), //证书查询
        meta: {
            title: "证书查询",
        }
    }]
}]

const router = new VueRouter({
    base: process.env.BASE_URL,
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

// 不纳入pageTab管理的路由
const filter = ["/", "/login", "/main", "/error", "/error/401", "/error/404","/h5","/h5/certificate_search"];

//全局守卫 路由拦截器
router.afterEach((to, from) => {
    var isLogin = sessionStorage.getItem("isLogin");
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (to.matched.length == 0) { //404
        router.replace("/error/404");
        return;
    }
    if (excludeRoutes.indexOf(to.name) != -1) {
        return;
    }
    if (!isLogin || userInfo == null) {
        Message.closeAll();
        Message.error("尚未登录");
        router.replace("/login");
        return;
    }
    if (!userInfo.isAdministrator && to.path.indexOf("admin") != -1) {
        Message.closeAll();
        Message.error("暂无权限");
        router.replace("/error/401");
    }
    // page tab管理
    if (filter.indexOf(to.fullPath) > -1) return;
    var routerTabs = store.state.pageTabs;
    var count = 0;
    for (var i = 0; i < routerTabs.length; i++) {
        var tab = routerTabs[i];
        tab.checked = tab.url == to.fullPath;
        count += tab.url == to.fullPath ? 1 : 0;
    }
    if (count == 0) {
        //不存在  新入栈
        routerTabs.push({
            title: to.meta.title,
            url: to.fullPath,
            checked: true,
        });
    }
    store.state.pageTabs = routerTabs;
});

// 拦截路由重复跳转异常
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch((err) => err);
};

export default router